// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { evmos as _evmos } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the evmos chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 9001
 * Chain Name: Evmos
 * Default Block Explorer: https://escan.live
 * Default RPC URL: https://eth.bd.evmos.org:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { evmos } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: evmos,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const evmos = createCommon({
	..._evmos,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
